import "./CapeCoralPestControl.module.css";
import Header from "@/reusable_sections/Header";
import CapeCoralPestControlHero from "./sections/CapeCoralPestControlHero";
import CapeCoralPestServices from "./sections/CapeCoralPestServices";
import PestControlProcess from "./sections/PestControlProcess";
import LocalCapeCoralPestControlExpertise from "./sections/LocalCapeCoralPestControlExpertise";
import ServiceCoverageFromCapeCoral from "./sections/ServiceCoverageFromCapeCoral";
import FinalCallToAction from "./sections/FinalCallToAction";
import EducationalPestInsights from "./sections/EducationalPestInsights";
import CapeCoralPestProblems from "./sections/CapeCoralPestProblems";
import PestControlFeatures from "./sections/PestControlFeatures";
import CapeCoralPestFaq from "./sections/CapeCoralPestFaq";
import Footer from "@/reusable_sections/Footer";
export default function CapeCoralPestControlPage() {
  return <div>
      <Header />
      <CapeCoralPestControlHero />
      <CapeCoralPestProblems />
      <CapeCoralPestServices />
      <PestControlProcess />
      <PestControlFeatures />
      <LocalCapeCoralPestControlExpertise />
      <EducationalPestInsights />
      <CapeCoralPestFaq />
      <ServiceCoverageFromCapeCoral />
      <FinalCallToAction />
      <Footer />
    </div>;
}